import { BaseStore } from '../stores';
import { action, computed, observable } from 'mobx';
import { Stores } from '../models/Stores';
import { EventPaginationChangeDetail, EventUpdatePaginationDetail } from 'src/models/eventManager/detail';
import { EventPublish, EventTypes } from 'src/models/eventManager';

export class PaginationStore extends BaseStore {
    @observable pageStart = 0;
    @observable pageLimit = 0;
    lastKnownIdentifier: string;

    constructor(stores: Stores) {
        super(stores);
    }

    @computed
    get config() {
        return this.stores.data.config;
    }

    @computed
    get appConfig() {
        return this.config && this.config.appConfig;
    }

    @computed
    get pagingConfig() {
        return this.config.paging;
    }

    @computed
    get identifier() {
        const pagingConfig = this.pagingConfig;

        if (pagingConfig && pagingConfig.identifier) {
            this.lastKnownIdentifier = pagingConfig.identifier;
            return pagingConfig.identifier;
        }

        return;
    }

	@action
	public handleChangeEvent = async (ev: EventPublish<EventPaginationChangeDetail>) => {
		const { newPagingData } = ev.detail;
		const { pageSize: pageLimit, recordIndex: pageStart } = newPagingData;
		this.updatePaging(pageStart, pageLimit);
	};

    @action
    updatePaging = (pageStart: number, pageLimit: number) => {
        this.pageStart = pageStart;
        this.pageLimit = pageLimit;
    };

    public updatePagination = async (totalRecords: number) => {
        if (this.pagingConfig.mode === 'paginationApp') {
            const { eventBusStore } = this.stores;
            eventBusStore.trigger<EventUpdatePaginationDetail>({
                type: EventTypes.UPDATE_PAGINATION,
                pagingData: {
                    pageSize: this.pageLimit,
                    recordIndex: this.pageStart,
                    totalRecords,
                },
            });
        } else {
            this.hidePagination();
        }
    };

    public hidePagination = async () => {
        if (this.lastKnownIdentifier) {
            this.lastKnownIdentifier = undefined;
        }
    };
}



// WEBPACK FOOTER //
// ./src/stores/PaginationStore.ts